import { render, staticRenderFns } from "./CoozzyViewListIcon.vue?vue&type=template&id=d9954ba8&scoped=true"
import script from "./CoozzyViewListIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyViewListIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyViewListIcon.vue?vue&type=style&index=0&id=d9954ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9954ba8",
  null
  
)

export default component.exports